module.exports = __webpack_public_path__ + "img/step02.9e2624f0.png";